import React from "react";
import { TabType } from "../../types";
import { useAppSelector } from "../../hooks/redux";
import styles from "./TabBar.module.css";
import { HapticFeedback } from "../../utils/hapticFeedback";
export interface TabItem {
  id: TabType;
  label: string;
  icon: React.ReactNode;
  badge?: number;
}

interface TabBarProps {
  tabs: TabItem[];
  activeTab: TabType;
  onTabChange: (tabId: TabType) => void;
  className?: string;
}

export const TabBar: React.FC<TabBarProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = "",
}) => {
  const { theme } = useAppSelector((state) => state.ui);

  const handleTabClick = (tabId: TabType) => {
    HapticFeedback.light();
    onTabChange(tabId);
  };

  return (
    <div
      className={`${styles.tabBar} ${
        theme === "dark" ? styles.dark : ""
      } ${className}`}
    >
      <div className={styles.tabBarInner}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tabItem} ${
              activeTab === tab.id ? styles.active : ""
            }`}
            onClick={() => handleTabClick(tab.id)}
          >
            <div className={styles.iconContainer}>
              {tab.icon}
              {/* {tab.badge && tab.badge > 0 && (
                <span className={styles.badge}>{tab.badge}</span>
              )} */}
            </div>
            <span className={styles.label}>{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
